import { Component, Input } from '@angular/core';
import { Utils } from 'src/app/@shared/utils/utils';
import {
  CobrancaDTO,
  CobrancaPixDTO,
  Locale,
} from 'src/app/core/types';
import Swal from 'sweetalert2';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-pix-payment',
  templateUrl: './payment-pix.component.html',
  styleUrls: ['./payment-pix.component.scss'],
})
export class PaymentPixComponent {
  @Input() locale: Locale = 'ptBR';
  @Input() cobranca: CobrancaDTO = {} as CobrancaDTO;
  loading: boolean = false;

  constructor(private sanitizer: DomSanitizer) { }

  getPixDetails(): CobrancaPixDTO {
    return this.cobranca.formaPagamento as CobrancaPixDTO;
  }

  get pixQrCodeBase64(): string {
    return `data:image/png;base64,${this.getPixDetails().qrCode}`;
  }

  getSafeImage(base64: string): SafeUrl {
    if (this.cobranca.provedor.toLocaleLowerCase() === 'cielo') {
      return this.sanitizer.bypassSecurityTrustUrl(
        'data:image/png;base64,' + base64
      );
    }

    return base64;
  }

  getVencimentoPix(): string {
    const pix = this.cobranca.formaPagamento as CobrancaPixDTO;
    return `Pagamento válido até ${Utils.formatDateString(
      pix.dataVencimento
    )} às ${Utils.formateTimeString(pix.dataVencimento)}`;
  }

  onClipboardCopy(successful: boolean): void {
    if (successful) {
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Código copiado com sucesso!',
        showConfirmButton: false,
        timer: 1500,
      });
    }
  }
}